export const usePublicAccess = (): {
  checkTokens: () => void;
} => {
  const route = useRoute();

  const userStore = useUserStore();

  const checkTokens = (): void => {
    userStore.accessToken = route.query.token
      ? (route.query.token as string)
      : undefined;
    userStore.publicToken = route.query.public_token
      ? (route.query.public_token as string)
      : undefined;
    userStore.itemPassword = route.query.password
      ? (route.query.password as string)
      : undefined;
  };

  // Populate tokens synchronously during setup so they are in the store
  // before any API query fires. usePublicAccess() runs once in the app root
  // (MainEntryPointApp.vue), whose setup precedes every child page's setup —
  // relying on onMounted instead races with queries that fire at setup and
  // sends token-less requests → sporadic 403 on public share links.
  checkTokens();

  watch(
    () => route.query,
    () => {
      checkTokens();
    },
    { deep: true }
  );

  return {
    checkTokens,
  };
};
